import Cookies from "js-cookie";

export const BASE_URL="https://api.nimmihardware.com/api/index.php"
export var  USER_NAME= ""
export var USER_ROLE= ""

export function setUserName (name:any,role:any) {
    USER_NAME = name;
    USER_ROLE = role;
}


export function hideOptions () : boolean {


    var cookiedata: any = Cookies.get('auth')

    if (!!cookiedata) {
      var cookieObj = JSON.parse(cookiedata)
      if (!!cookieObj && !!cookieObj.username) {

        var role = cookieObj.userrole;

        if (role == "E") {
          return true;
        }

      } else {

      }

    } else {

    }
   return false;
}


export function isUserAuthenticated () : boolean {


    var cookiedata: any = Cookies.get('auth')

    if (!!cookiedata) {
      var cookieObj = JSON.parse(cookiedata)
      if (!!cookieObj && !!cookieObj.username) {

        var role = cookieObj.userrole;

        if (role == "E" || role == "S") {
          return true;
        }

      } else {

      }

    } else {

    }
   return false;
}


export function  isValidFileName (param: any) : boolean{
  var specialCharsss = /[`!@#$%^&*()+\-=\[\]{};':"\\|,<>\/?~\ ]/;
  return !specialCharsss.test(param)
}
